import getRoundedToNearestHour from './getRoundedToNearestHour';

const TICK_COUNT = 24;

export default (dateFrom: number, dateTo: number): number => {
  const dateFromRn = getRoundedToNearestHour(dateFrom);
  const dateToRn = getRoundedToNearestHour(dateTo);

  return Math.round((dateToRn - dateFromRn) / TICK_COUNT);
};
